import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  requestConfig,
  throwFromFailedResponse,
} from "../../globals";

export const deleteAccountProps = z
  .object({ token: z.string() })
  .extend(requestConfig.shape);

export type DeleteAccountProps = z.infer<typeof deleteAccountProps>;

export const deleteAccount = async (
  args: DeleteAccountProps,
): Promise<void> => {
  const { endpoint = env.ACCOUNT_SERVICE_URL, token } = parseServiceInput(
    deleteAccountProps,
    args,
  );

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  });

  const response = await fetch(`${endpoint}/v1/account`, {
    method: "DELETE",
    headers,
  });
  if (!response.ok) {
    await throwFromFailedResponse(response);
  }

  return;
};
